// @ts-ignore
import { getInstance } from "@/auth/auth0";
import { getUserData } from "@/auth/getUserData";
import { register } from "register-service-worker";

const getToken = (): Promise<string> =>
    new Promise((resolve) => {
        const instance = getInstance();

        instance.$watch(
            "loading",
            async (isLoading: boolean) => {
                if (isLoading) {
                    return;
                }

                const { auth0Client } = getInstance();

                if (!auth0Client) {
                    return;
                }

                const { id_token } = await auth0Client.getTokenSilently({ detailedResponse: true });

                resolve(id_token);
            },
            {
                immediate: true,
            }
        );
    });

const getNotificationPermission = async (): Promise<NotificationPermission> => {
    if (!("Notification" in window)) {
        return "denied";
    }

    let permission = window.Notification.permission;

    if (permission === "default") {
        permission = await window.Notification.requestPermission();
    }

    return permission;
};

const initServiceWorker = async (serviceWorker: ServiceWorker | null) => {
    if (!serviceWorker) {
        return;
    }

    const [permission, token] = await Promise.all([getNotificationPermission(), getToken()]);

    if (permission !== "granted") {
        return;
    }

    const user = getUserData();

    const languageSetting = user.settings.find((setting) => setting.name === "language");

    serviceWorker.postMessage({
        type: "SET_SCOPE",
        scope: {
            token,
            user,
            language: languageSetting?.value ?? "en",
            publicVapidKey: process.env.VUE_APP_PUBLIC_VAPID_KEY,
            publicApi: process.env.VUE_APP_PUBLIC_API,
        },
    });

    serviceWorker.postMessage({
        type: "SET_PUSH_SUBSCRIPTION",
    });
};

// Console logs are commented out for easy debugging later on
const hooks = {
    ready(registration: ServiceWorkerRegistration) {
        initServiceWorker(registration.active);
    },
    registered() {
        // Service worker has been registered.
    },
    cached() {
        // Content has been cached for offline use.
    },
    updatefound() {
        // New content is downloading.
    },
    async updated(registration: ServiceWorkerRegistration) {
        await initServiceWorker(registration.waiting);

        registration.waiting?.postMessage({ type: "SKIP_WAITING" });
    },
    offline() {
        // No internet connection found. App is running in offline mode.
    },
    error(error: Error) {
        // Error during service worker registration.
    },
};

if (process.env.NODE_ENV === "production") {
    register(`${process.env.BASE_URL}service-worker.js`, hooks);
} else {
    register(`${process.env.BASE_URL}push-service-worker.js`, hooks);
}
